import React from 'react';
import { Box } from '@mui/material';
import { DAY_CELL_WIDTH } from '../helpers';

interface HeatmapDayColumnProps {
  height?: number | '100%';
  fullBorder?: boolean;
  topBorder?: boolean;
  hasBottomBorder?: boolean;
  children?: React.ReactNode;
}

const HeatmapDayColumn: React.FC<HeatmapDayColumnProps> = ({
  height = 32,
  fullBorder = false,
  topBorder = false,
  hasBottomBorder = false,
  children,
}) => (
  <Box
    component="span"
    sx={{
      width: DAY_CELL_WIDTH,
      flexShrink: 0,
      borderLeft: `.3px solid`,
      borderRight: `.3px solid`,
      ...(fullBorder && { border: '.3px solid' }),
      ...(topBorder && { borderTop: '0.3px solid' }),
      ...(hasBottomBorder && { borderBottom: '0.3px solid' }),
      height,
      display: 'block',
      borderColor: 'divider',
    }}
  >
    {children}
  </Box>
);

export default React.memo(HeatmapDayColumn);
